import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BottomAddEditBox from "../../../components/site_management/bottom-add-edit-box";
import ButtonBack from "../../../components/site_management/button-back";
import InputSiteDetailBox from "../../../components/site_management/input-site-detail-box";
import ContentBuildingInfo from "../../../components/site_management/input-site-detail-box/building-info";
import ContentMapLatLng from "../../../components/site_management/input-site-detail-box/map-latlng";
import PopupModalConfirmDelete from "../../../components/site_management/popup-modal/confirm-delete";
import PopupModalError from "../../../components/site_management/popup-modal/error";
import PopupModalLoading from "../../../components/site_management/popup-modal/loading";
// import CoreAPI from '../../../shared/services/core';
import { addSite, editSite, getSiteById } from "../../../api/site";
import { useTranslation } from 'react-i18next'
import { useDempStore } from "src/context/stores";

function SiteAddEditPage({isEdit}) {
    const paramsUrl = useParams();
    const navigate = useNavigate();
    // ==============================
    // Use Zustand store instead of localStorage
    const [companyId] = useDempStore((state) => [state.companyId]);
    // console.log('CompanyId from store:', companyId);
    if (!companyId) {
        console.warn('Warning: No companyId found in store');
    }
    const { t } = useTranslation("settings");

    //==============================
    const [isLoading, setIsLoading] = useState(false);
    const [isPopupError, setIsPopupError] = useState(false);
    const [isPopupConfirmDelete, setIsPopupConfirmDelete] = useState(false);
    const [labelError, setLabelError] = useState('');
    const [detailSite, setDetailSite] = useState({
        Id: '',
        No: '',
        NameEn: '',
        NameTh: '',
        Type: '',
        TypeId: '',
        Description: '',
        Address: '',
        Image: '',
        ImageName: '',
        ImageId: 0,
        ImageFile: null,
        ImageFileName: '',
        Latitude: '',
        Longitude: '',
        Config: ''
    })
    const isPageEditRef = useRef(false);
    const [listAlertRequiredField, setListAlertRequiredField] = useState([]);

    useEffect(() => {
        const init = async () => {
            setInitRoute();
        }
        init();
    }, [])

    function setAlertMessage(message) {
        setListAlertRequiredField([message]);
    }


    function setInitRoute() {
        if (paramsUrl.id) {
            isPageEditRef.current = true;
            onSetDetailSite(paramsUrl['id']);
        } else {
            isPageEditRef.current = false;
            onSetDetailSite();
        }
    }
    async function onSetDetailSite(param) {
        setIsLoading(true);
        //==============================
        let detail = {
            ...detailSite,
            // No need to set CompanyId in state since we're using store value directly
        }
        if (!param) {
            // detail.No = randomString(10);
            // detail.Id = randomString(10);
        } else {
            const response = await getSiteById(param)
            if (response.status) {
                const dataResponse = response.data;
                
                let detailLatLng = JSON.parse(dataResponse.location);
                detailLatLng = (typeof detailLatLng === 'string') ? JSON.parse(detailLatLng) : detailLatLng;
                
                // console.log(detailLatLng,"detailLatLng")
               
                detail = {
                    ...detail,
                    Id: dataResponse.id,
                    No: '',
                    NameEn: dataResponse.name,
                    NameTh: '',
                    Type: '',
                    TypeId: '',
                    Description: dataResponse.description,
                    // Address: dataResponse.address,
                    Image: dataResponse?.main_image_file,
                    // ImageName: imageName,
                    // ImageId: imageId,
                    ImageFile: null,
                    // AlbumImage: listImage,
                    Latitude: detailLatLng.lat ? detailLatLng.lat : dataResponse.Latitude,
                    Longitude: detailLatLng.lon ? detailLatLng.lon : dataResponse.Longitude,
                    Address: dataResponse?.address_id,
                    config: dataResponse?.config,
                    location: dataResponse?.location,
                    // We don't need to store CompanyId in state anymore
                    originalAddress: {
                        province: dataResponse.address?.province || '',
                        district: dataResponse.address?.district || '',
                        sub_district: dataResponse.address?.sub_district || ''
                    }
                }
                // console.log('Loaded site data');
            }
        }
        setDetailSite(detail);
        //==============================
        setTimeout(() => {
            setIsLoading(false);
        }, 1000);
    }
    function randomString(length) {
        var text = "";
        var possible =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < length; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return text;
    }
    function onSetSiteDetail(param) {
        setDetailSite(param);
        onCheckRequireFillAlert(param, false)
    }
    function onSetSiteDetailLatLng(param) {
        const detail = {
            ...detailSite,
            Latitude: param.Latitude,
            Longitude: param.Longitude,
        }
        setDetailSite(detail);
    }

    
    function onCheckRequireFill() {
        let check = true;
        if (!detailSite.NameEn) {
            check = false;
            onCheckRequireFillAlert({ ...detailSite, NameEn: true }, true); // This will set the alert for Name
        }
        if (!detailSite.Latitude || !detailSite.Longitude) {
            check = false;
            onCheckRequireFillAlert(detailSite, true); // This will set the alert for Latitude and Longitude
        }
        // We're now using companyId from store, so no need to check detailSite.CompanyId
        if (!companyId) {
            console.warn('Warning: Missing companyId in store when validating form');
            // Not setting as required since it might be handled server-side
        }
        return check;
    }


    function onCheckRequireFillAlert(fields, fromSave,param) {
        let listAlertInput = [];
        if (fromSave) {
            if (!param.NameEn) listAlertInput.push('Name');
            if (!param.Latitude) listAlertInput.push('Latitude');
            if (!param.Longitude) listAlertInput.push('Longitude');
        } else {
            listAlertInput = listAlertRequiredField.slice();
            if (param.NameEn) listAlertInput = listAlertInput.filter(field => field !== 'Name');
            if (param.Latitude) listAlertInput = listAlertInput.filter(field => field !== 'Latitude');
            if (param.Longitude) listAlertInput = listAlertInput.filter(field => field !== 'Longitude');
        }
        setListAlertRequiredField(listAlertInput);

    }
    

    function onClickBack() {
        navigate("/site", { replace: false });
    }


    async function onClickSaveAndDupSite() {
        if (!onCheckRequireFill()) return;
        const statusSave = await onSaveSite();
        if (statusSave) {
            isPageEditRef.current = false;
            navigate("/site/add", { replace: false });
        } else {
            setIsPopupError(true);
        }
    }
    

    async function onClickSaveSite() {
        if (!onCheckRequireFill()) {
            return;
        }
        if (!detailSite.Latitude || !detailSite.Longitude) {
            onCheckRequireFillAlert(['Latitude', 'Longitude'], true);
            return;
        }
        const statusSave = await onSaveSite();
        if (statusSave) {
            navigate("/site", { replace: false });
        } else {
            setIsPopupError(true);
        }
    }
    


    async function onSaveSite() {
        setIsLoading(true);
        //==============================
        let statusSave = false;
        let siteId;
        let imageId = detailSite.ImageId;
        
        // Ensure we have a valid companyId from store
        const validCompanyId = Number(companyId) || 0;
        // console.log('Using companyId for API call:', validCompanyId);
        
        const plantInfo ={
            "name": "string",
            "description": "string",
            "location": "string", // longitude and latitude (stringify the object)
            "plant_code": "string",  // this is branch code
        
            "is_head_office": true,
            "main_image": "FILE", //this is a file object
            "company": validCompanyId, //using the company id from store
            
            config:{ //(stringify the address object)
                "business_type": "string",
                "landlord": "string",
                "plant_code": "string",
                "date_of_implementation": "string",
                "tax_id": "string",
                "attachedFile": "FILE", //this is a file object
        
            },
            "address":{ //(stringify the address object)
                "address_no": "string",
                "moo_no": "string",
                "building_name": "string",
                "floor_no": "string",
                "room_no": "string",
                "soi": "string",
                "road_name": "string",
                "is_active": true,
                "sub_district": "string",
            }
        }

      
        const formattedData = new FormData();
        formattedData.append('name', detailSite.NameEn);
        formattedData.append('description', detailSite?.Description);
        formattedData.append('location', JSON.stringify({lat: detailSite?.Latitude ??"", lon: detailSite?.Longitude??""}));
        formattedData.append('plant_code', detailSite?.Id);
        formattedData.append('is_head_office', true);
        formattedData.append('company', validCompanyId);

        formattedData.append('config', JSON.stringify({
            "business_type": detailSite?.business_type || "",
            "plant_code": detailSite?.plant_code || "",
            "landlord": detailSite?.landlord || "",
            "date_of_implementation": detailSite?.date_of_implementation || "",
            "tax_id": detailSite?.tax_id || "",
            "attachedFile": detailSite?.attachedFile || ""
        }));
        
        formattedData.append('address', JSON.stringify({
            "address_no": detailSite?.address_no || detailSite?.Address?.address_no || "",
            "moo_no": detailSite?.moo_no || detailSite?.Address?.moo_no || "",
            "building_name": detailSite?.building_name || detailSite?.Address?.building_name || "",
            "floor_no": detailSite?.floor_no || detailSite?.Address?.floor_no || "",
            "room_no": detailSite?.room_no || detailSite?.Address?.room_no || "",
            "soi": detailSite?.soi || detailSite?.Address?.soi || "",
            "road_name": detailSite?.road_name || detailSite?.Address?.road_name || "",
            "sub_district": detailSite?.sub_district || detailSite?.Address?.sub_district || ""
        }));
        

        if(detailSite?.mainImage?.File && !isEdit){
            formattedData.append('main_image', detailSite?.mainImage?.File);
        }
        if(detailSite?.mainImage?.File && isEdit){
            formattedData.append('logo', detailSite?.mainImage?.File);
        }
        

        let responseAdd;
        if (!isEdit) {
            responseAdd = await addSite(formattedData);
        } else {
            siteId = Number(detailSite.Id);
            responseAdd = await editSite(siteId, formattedData);
        }

        if (responseAdd?.status && !responseAdd?.data?.data?.error) {
            statusSave = true;
            setLabelError(`${t('site_management.confirm.save')}`);
            return statusSave;
        }else{
            setLabelError(responseAdd?.data?.data?.error ?? `${t('site_management.confirm.filled')}`);
            statusSave = false;
            return statusSave;
        }

        
    }
    async function onClickConfirmDeleteFunc() {
        setIsPopupConfirmDelete(false);
    }

   
    return (
        <div className="relative w-full h-screen">
            {isLoading &&
                <PopupModalLoading isOpen={isLoading} />
            }
            {isPopupError &&
                <PopupModalError
                    isOpen={isPopupError}
                    text={labelError}
                    onClickClose={(e) => { setIsPopupError(false) }}
                />
            }
            {isPopupConfirmDelete &&
                <PopupModalConfirmDelete
                    isOpen={isPopupConfirmDelete}
                    // text={labelItem}
                    onClickClose={(e) => { setIsPopupConfirmDelete(false) }}
                    onClickConfirm={(e) => { onClickConfirmDeleteFunc() }}
                />
            }
            <div className="h-full px-6 pb-20 overflow-y-auto">
                {/* ========== Header Fuction Content ========== */}
                <div className="w-full h-[72px] flex items-center">
                    <ButtonBack
                        text={`${t('site_management.back')}`}
                        onClick={(e) => { onClickBack() }}
                    />
                </div>
                {/* ========== Input Site Detail Content ========== */}
                <InputSiteDetailBox
                    isEdit={isPageEditRef.current}
                    detailSite={detailSite}
                    alertRequiredField={listAlertRequiredField}
                    onChangeDetail={(e) => { onSetSiteDetail(e) }}
                />

                {!isPageEditRef.current && <div className="w-full h-[500px] mt-4 flex">
                    {/* map: to select lat and long */}
                    <div className="w-full h-full mr-4">
                        <ContentMapLatLng
                            detailLatLng={detailSite}
                            onSetLatLng={(e) => { onSetSiteDetailLatLng(e) }}
                        />
                    </div>
                </div>}

                {isPageEditRef.current &&
                <div className="w-full h-[500px] mt-4 flex">
                    {/* map: to select lat and long */}
                    <div className="w-1/2 h-full mr-4">
                        <ContentMapLatLng
                            detailLatLng={detailSite}
                            onSetLatLng={(e) => { onSetSiteDetailLatLng(e) }}
                        />
                    </div>
                    <div className="w-full h-full mrl-4">
                        <ContentBuildingInfo
                            siteId={detailSite.Id}
                            disable={!isPageEditRef.current} />
                    </div>
                </div> }
            </div>
            <div className="absolute bottom-0 left-0 flex justify-center w-full h-12 bg-white shadow-content-box">
                <BottomAddEditBox
                    onClickSaveAndDup={(e) => { onClickSaveAndDupSite() }}
                    onClickSave={(e) => { onClickSaveSite() }}
                />
            </div>
        </div>
    )
}

export default SiteAddEditPage;